const version = '0.5.5.0';

export { version };
